import React from 'react';

const Footer = () => {
  return (
    <div className='text-center p-10 mt-10 border-t dark:border-gray-700 border-gray=200'>
      &copy;2021{' '}
      <a href='https://www.linkedin.com/in/web-stack-learner/' rel='noreferrer'>
        Borhan Uddin
      </a>
      ||{' '}
      <a
        href='https://github.com/Web-Stack-Learner'
        target='_blank'
        rel='noopener noreferrer'
      >
        Web Stack Learner
      </a>
    </div>
  );
};

export default Footer;
